/* eslint-disable no-unused-vars */
import React from 'react'
import { Content, ActionsContent, ButtonContent } from './styled'
import Button from '../../../components/inputs/ButtonLink'
import Layout from '../../components/layout_user'
import Container from '../../components/container'
import Summary from './components/summary'
import Shipping from './components/shiping'
import MethodPay from './components/method_pay'
import InfoCard from './components/credit_card_form'
import Confirm from './components/confirm'

import { number, string, arrayOf, func } from 'prop-types'

const View = props => {
  return (
    <Layout>
      <Container style={{ marginTop: '50px' }}>
        <Content>
          <ActionsContent>
            {props.currentStep === 0 && (
              <Shipping {...props} />
            )}
            {props.currentStep === 1 && (
              <MethodPay {...props} />
            )}
            {props.currentStep === 2 && (
              <InfoCard {...props} />
            )}
            {props.currentStep === 3 && (
              <Confirm {...props} />
            )}
          </ActionsContent>
          <Summary {...props} />
        </Content>
      </Container>
    </Layout>
  )
}

View.propTypes = {
  currentStep: number,
  steps: arrayOf(string),
  goToStep: func,
  handleNext: func
}

export default View
